import createIcon from '../../createIcon';

/**
 * @component @name Blinds
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTlWM0g0VjE5SDJWMjFIMjJWMTlIMjBaTTE2IDlIMThWMTFIMTZWOVpNMTQgMTFINlY5SDE0VjExWk0xOCA3SDE2VjVIMThWN1pNMTQgNVY3SDZWNUgxNFpNNiAxOVYxM0gxNFYxNC44MkMxMy41NSAxNS4xNCAxMy4yNSAxNS42NiAxMy4yNSAxNi4yNUMxMy4yNSAxNy4yMiAxNC4wMyAxOCAxNSAxOEMxNS45NyAxOCAxNi43NSAxNy4yMiAxNi43NSAxNi4yNUMxNi43NSAxNS42NiAxNi40NSAxNS4xMyAxNiAxNC44MlYxM0gxOFYxOUg2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Blinds = createIcon('Blinds', [
  [
    'path',
    {
      d: 'M20 19V3H4V19H2V21H22V19H20ZM16 9H18V11H16V9ZM14 11H6V9H14V11ZM18 7H16V5H18V7ZM14 5V7H6V5H14ZM6 19V13H14V14.82C13.55 15.14 13.25 15.66 13.25 16.25C13.25 17.22 14.03 18 15 18C15.97 18 16.75 17.22 16.75 16.25C16.75 15.66 16.45 15.13 16 14.82V13H18V19H6Z',
      key: '1kpc2k',
    },
  ],
]);

export default Blinds;
